import { Navigate } from "react-router-dom";

export default function RegisterBuyer() {
  return <Navigate to="/register/enterprise" replace />;
}
